import { AxiosError } from "axios";

export default class ErrorUtils {
    public static getErrorMessage(error:unknown): string {
        if (error instanceof AxiosError) {
            return this.getAxiosErrorMessage(error);
        } else if (error instanceof Error) {
            return error.message;
        } else if (error instanceof String) {
            return error.toString();
        }         
        return "Erreur technique";
    }

    private static getAxiosErrorMessage(error:AxiosError): string {
        //On vérifie d'abord si le statut est 403 (FORBIDEN) : 
        if (error.response?.status === 403) {
            return "You do not have permission to access this resource. Please contact an administrator if you believe that you need access to this resource";
        }
        // le serveur ne renvoie que deux type d'erreurs :
        // Soit : Constraint Violation Object 
        // Soit : Objet ApiResponse with List<String> errors
        let data:any = error.response?.data;
        if(data.violations) {
            // Cas des erreurs de validation "automatique" de bean (ex. annotations NotBlank sur les attributs côté serveur)
            return data.violations.map((violation:any) => violation.message).join(", ");
        } else {
            const apiResponse = this.mapToApiResponse<unknown>(error);
            return apiResponse.errors.join(", ");
        }
    }

    private static mapToApiResponse<T>(error: AxiosError): ApiResponse<T> {
        if (error.response && error.response.data) {
          const responseData = error.response.data as Partial<ApiResponse<T>>;
          return {
            data: responseData.data || null,
            errors: responseData.errors || ["An unknown error occurred"],
          };
        }
    return {
        data: null,
        errors: [error.message || "An unexpected error occurred"],
      };
    }
}